<template>
  <fragment>
    <AppBody
      :title="$t('reports.eleven.consumers')"
      :subtitle="$t('reports.eleven.consumers')"
      disableDivider
    >
      <CardModule untitle>
        <v-form
          @submit.prevent="$relatorios_analiticos.filtroConsumidoresOmni()"
          class="search-forms"
        >
          <v-row v-if="isAdmin">
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni.nomeConsumidor
                "
                :label="$t('reports.eleven.consumer')"
                :placeholder="$t('reports.eleven.insert-consumer-name')"
                type="text"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'nomeConsumidor'
                  )
                "
                hide-details
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                :label="$t('reports.eleven.state')"
                :placeholder="$t('reports.eleven.select-state')"
                :no-data-text="$t('reports.no-info-found')"
                item-text="dsc_lang"
                return-object
                autocomplete="null"
                clearable
                auto-select-first
                :loading="$config.loading_estados"
                :items="$config.estados.result"
                v-model="estado"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'estado'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                v-model="$relatorios_analiticos.filterConsumidoresOmni.cidade"
                :label="$t('reports.eleven.city')"
                :placeholder="$t('reports.eleven.select-city')"
                :no-data-text="$t('reports.no-info-found')"
                item-text="dsc_lang"
                item-value="dsc_lang"
                clearable
                :loading="$config.loading_cidades"
                :items="$config.cidades.result"
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'cidade'
                  )
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                v-model="
                  $relatorios_analiticos.filterConsumidoresOmni.promocoes
                "
                :label="$t('reports.eleven.promotions-and-campaigns')"
                :items="$relatorios_analiticos.promocoes"
                item-text="text"
                item-value="value"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterConsumidoresOmniFields(
                    'promocoes'
                  )
                "
              />
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.eleven.initial-birth-date')"
                @formatted-date="handleInitDateTimeBirth"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.eleven.final-birth-date')"
                @formatted-date="handleEndDateTimeBirth"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.eleven.initial-register-date')"
                @formatted-date="handleInitDateTimeCreation"
              ></date-time-picker>
            </v-col>

            <v-col cols="12" md="3" sm="4">
              <date-time-picker
                :label="$t('reports.eleven.final-register-date')"
                @formatted-date="handleEndDateTimeCreation"
              ></date-time-picker>
            </v-col>

            <v-col class="d-flex justify-end">
              <BaseButton
                variant="filter"
                data-cy="filtrar"
                type="submit"
                :loading="
                  $relatorios_analiticos.loading_relatorio_consumidores_omni
                "
              >
                {{ $t("reports.generate-and-send") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "ConsumerAnalytical",
  metaInfo() {
    const title = this.$t("reports.eleven.consumers");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  props: {},
  components: {
    CardModule,
    DateTimePicker,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      dayjs: dayjs,
      estado: null,
      cidades: [],
    };
  },
  watch: {
    estado(state) {
      const { id, iso_full } = state;
      this.$relatorios_analiticos.filterConsumidoresOmni.estado = iso_full;

      const filteredId = this.$config.estados.result.find(
        item => item.dsc === state
      );

      this.$config.getCidades(id || filteredId.id);
    },
  },
  methods: {
    handleInitDateTimeBirth(formatteddatetime) {
      this.$relatorios_analiticos.filterConsumidoresOmni.initDateTimeBirth =
        formatteddatetime;
    },
    handleEndDateTimeBirth(formatteddatetime) {
      this.$relatorios_analiticos.filterConsumidoresOmni.endDateTimeBirth =
        formatteddatetime;
    },
    handleInitDateTimeCreation(formatteddatetime) {
      this.$relatorios_analiticos.filterConsumidoresOmni.initDateTimeCreation =
        formatteddatetime;
    },
    handleEndDateTimeCreation(formatteddatetime) {
      this.$relatorios_analiticos.filterConsumidoresOmni.endDateTimeCreation =
        formatteddatetime;
    },
  },

  computed: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  beforeMount() {
    this.$axios.setLocal("person_type", "LOJA");
  },
  mounted() {
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");
  },
  destroyed() {
    this.$relatorios_analiticos.limpaFiltrosConsumidoresOmni();
  },
};
</script>
<style scoped></style>
